<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs12 md8 offset-md2>
          <v-card flat class="card--flex-toolbar" color="transparent">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2 class="white--text">Trenerzy</h2>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg5 v-for="item in links" :key="item.id">
                  <v-hover>
                    <v-card
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 12 : 2}`"
                    >
                      <v-img
                        src=""
                        aspect-ratio="2.75"
                        height="125px"
                        :class="item.color"
                      ></v-img>

                      <v-card-title primary-title>
                        <v-list-item>
                          <v-avatar size="100px">
                            <img alt="Avatar" v-bind:src="item.src" />
                          </v-avatar>
                          <h3 class="headline mb-0">{{ item.title }}</h3>
                          <v-chip
                            v-for="tag in item.tags"
                            :key="tag.id"
                            class="ma-2"
                            small
                            color="primary"
                            text-color="white"
                          >
                            <v-avatar left>
                              <i class="fas fa-hashtag"></i>
                            </v-avatar>
                            {{ tag.text }}
                          </v-chip>
                          <p>{{ item.description }}</p>
                        </v-list-item>
                      </v-card-title>
                      <v-card-actions v-if="item.showLinks == true">
                        <v-btn
                          flat
                          color="primary"
                          class="learn-more-btn"
                          :href="item.linkedInLink"
                        >
                          <i class="fab fa-linkedin"></i>
                        </v-btn>
                        <v-btn
                          flat
                          color="primary"
                          class="learn-more-btn"
                          :href="item.websiteLink"
                        >
                          <i class="fas fa-link"></i>
                        </v-btn>
                        <v-btn
                          flat
                          color="primary"
                          class="learn-more-btn"
                          :href="item.gitLink"
                        >
                          <i class="fab fa-gitlab"></i>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          id: "1",
          title: "Tomasz Diakowski",
          description:
            "Ceo Akademii testowania. Tester od 2008 roku na różnych stanowiskach - od testera manualnego przez automatyzującego jak również leadera. Od 2 lat dzieli się swoją wiedzą prowadząc szkolenia z automatyzacji testowania. ",
          color: "primary-color-bg",
          src:
            "data:image/jpeg;base64,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",
          showLinks: true,
          linkedInLink: "http://linkedin.com/in/tomasz-diakowski-03aa0a20",
          websiteLink: "",
          gitLink: "",
          tags: [
            { id: 1, text: "Selenium" },
            { id: 2, text: ".NET" },
            { id: 3, text: "Java" },
          ],
        },
        {
          id: "2",
          title: "Katarzyna Białas",
          description:
            "Absolwentka Politechniki Wrocławskiej. Na co dzień Software Developer w jednym z centrów R&D. Jest Specjalistką z programowania w języku C# oraz systemu kontroli wersji GIT. ",
          color: "skyblue-color-bg",
          src:
            "https://zbclabs.dev/wp-content/uploads/2017/09/foto-e1504722322926.jpg",
          showLinks: true,
          linkedInLink: "http://linkedin.com/in/katarzyna-bia%C5%82as",
          websiteLink: "https://zbclabs.dev/kb",
          gitLink: "https://gitlab.com/winmaster",
          tags: [
            { id: 1, text: "GIT" },
            { id: 2, text: ".NET" },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.outine-2 {
  border: 2px solid white;
}

.card--flex-toolbar {
  margin-top: -124px;
}

.learn-more-btn {
  text-transform: initial;
  text-decoration: underline;
}
</style>
